import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { AddressDisplay } from "../../../../../../../react-core/Html/Address/AddressDisplay";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AccountRole } from "../../../../../../../Wrap/Models/Domains/Account/AccountRole";
import { ClientAccount } from "../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { AddressDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Action } from "../../../../../Actions/Action";
import { NewBusinessAction } from "../../../NewBusinessWizard/Actions/NewBusinessAction";
import { isCreatingNewAccount } from "../../../NewBusinessWizard/Components/WrapperSelection/WrapperSelctionHelper";
import { CustomerContextStoreStatic } from "../../../NewBusinessWizard/Stores/Variable";
import { PortfolioDashboardAction } from "../../../PortfolioDashboard/Action/PortfolioDashboardAction";
import { PortfolioDashboardStore } from "../../../PortfolioDashboard/Store/Variable";
import { SubAccountTypeHelper } from "../../Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../../Resource/Contents";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { BankAccountWarning } from "./BankAccountWarning";
import { ClientPortalAccess } from "./ClientPortalAccess";
import { Declarations } from "./Declarations";
import { Documents } from "./Documents";
import { ESignatureDoc } from "./ESignatureDoc";
import { NewTpsWarning } from "./NewTpsWarning";
import { ActorSubType } from "../../../../../../../Wrap/Constants/Enums/ActorSubType";
import { SubAccountActionIndicators } from "../../../../../../../Wrap/Models/Models/Shared/SubAccountActionIndicators";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { DocumentDeclarationWarningMessage } from "../Resource/Content";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { PaperLess } from "../../PaymentsIn/PaperLess";

interface IDocumentsAndDeclarationsProps extends IProcessComponentProps {
    data:
    | ApplyModel
    | GiaContributionModel
    | IsaContributionModel
    | PensionContributionModel
    | WrapCashContributionModel;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    isJointOrTrust: boolean;
    clAccountId?: string;
    customerId?: number;
    selectedProducts?: Array<SubAccountActionIndicators>;
    buyAllocations?: InvestmentAllocation[];
}

interface IDocumentsAndDeclarationsState {
    tasksForESign: { fileName: string; taskRequestId: number }[];
    allAccounts: ClientAccount[];
    customerData: FullClientDetailModel;
    senderAddress: AddressDetailModel;
    isCashDeclarationChecked: boolean;
}

export class DocumentsAndDeclarations extends ProcessComponent<
    IDocumentsAndDeclarationsProps,
    IDocumentsAndDeclarationsState
> {
    constructor(props: IDocumentsAndDeclarationsProps) {
        super(props);
        this.state = {
            tasksForESign: [],
            allAccounts: PortfolioDashboardStore.getData(),
            customerData: CustomerContextStoreStatic.getData(),
            senderAddress: null,
            isCashDeclarationChecked: false,
        };
        this.subscribeToStore(CustomerContextStoreStatic, () => this.onCustomerContextStoreChange());
        this.subscribeToStore(PortfolioDashboardStore, () => this.onAllAccountsChange());
    }

    isValid() {
        return super.isValid();
    }

    onAllAccountsChange() {
        this.setState({ allAccounts: PortfolioDashboardStore.getData() });
    }

    handleCashDeclarationChange = (event) => {
        this.setState({ isCashDeclarationChecked: event });
    };

    onCustomerContextStoreChange() {
        const data = CustomerContextStoreStatic.getData()?.AddressDetails;
        if (data) {
            this.setState({
                customerData: CustomerContextStoreStatic.getData(),
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        const params = getQueryParameters();
        InstructionDocumentTypeRequestTriggerActionsCreator.getAddress((address) => {
            this.setState({ senderAddress: address });
        });
        if (
            this.props.processType == processTypeEnum.NewBusiness ||
            this.props.processType == processTypeEnum.NewBusinessExistingClient ||
            this.props.processType == processTypeEnum.SinglePaymentTransfer ||
            this.props.processType == processTypeEnum.RegularPayment
        ) {
            if (!CommonHelper.isNullOrEmpty(params["hierarchyid"]) && !PortfolioDashboardStore.getData()) {
                if (params["customerid"])
                    {PortfolioDashboardAction.getAllAccountsByCustomerId(Number(params["customerid"]));}
                else {PortfolioDashboardAction.getAllAccountsByCustomerId(this.props.customerId);}
            }
        }
        if (!this.state.customerData && !CommonHelper.isNullOrEmpty(params["hierarchyid"])) {
            Action.getAccountRoles(params["hierarchyid"], (res: AccountRole[]) => {
                const actorId = res.find((x) => x.IsPrimary == true).Customer.CustomerId;
                NewBusinessAction.accountHolderAction(actorId, (res) => {
                    this.setState({ customerData: res });
                });
            });
        }

        {
            this.props.selectedProducts?.some((ele) => ele.SubAccountType == SubAccountType.JuniorSipp) && (
                this.onDataChange(
                    this.props.onChange,
                    {
                        ActorSubType: ActorSubType.Child
                    },
                    this.props.data,
                    "ClientDetails"
                )
            )
        };
    }

    private needGoToDlu = () => {
        const { processType, data } = this.props;
        if (
            processType == processTypeEnum.NewBusiness ||
            this.props.processType == processTypeEnum.NewBusinessExistingClient
        ) {
            return (data as ApplyModel).SelectedProducts.some((ele) =>
                SubAccountTypeHelper.isBond(ele.SubAccountType)
            );
        }
        return false;
    };

    private onTasksForEsign(val) {
        if (this.state.tasksForESign.some((ele) => ele.fileName == val.fileName)) {
            this.state.tasksForESign.find((ele) => ele.fileName == val.fileName).taskRequestId = val.taskRequestId;
        } else {
            this.setState({ tasksForESign: this.state.tasksForESign.concat(val) });
        }
    }

    render() {
        const hasLegacyProduct = this.needGoToDlu();
        return (
            <>
                {this.getDocumentWarning()}
                <BankAccountWarning {...this.props} onRef={(ref) => this.appendChild(ref)} />
                <NewTpsWarning {...this.props} onRef={(ref) => this.appendChild(ref)} />
                <Documents
                    {...this.props}
                    needGoToDlu={hasLegacyProduct}
                    onTasksForEsign={(val) => this.onTasksForEsign(val)}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <br />
                <div className="panel-green">
                    <p>For postal documentation, send any completed forms to:</p>{" "}
                    <AddressDisplay address={this.state.senderAddress} />
                </div>
                {!hasLegacyProduct && (
                    <ESignatureDoc
                        {...this.props}
                        isJuniorSipp={this.props.selectedProducts?.some(x => x?.SubAccountType == SubAccountType.JuniorSipp) 
                            || this.props.subAccountType == SubAccountType.JuniorSipp}
                        taskRequests={this.state.tasksForESign}
                        customerData={this.state.customerData}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                )}

                {this.props.processType == processTypeEnum.NewBusiness &&
                    isCreatingNewAccount(
                        getQueryParameters()["hierarchyid"],
                        this.props.data,
                        this.state.allAccounts
                    ) && <ClientPortalAccess {...this.props} />}

                {this.props.processType == processTypeEnum.NewBusiness &&(
                    <PaperLess
                        onRef={(ref) => this.appendChild(ref)}
                        data={this.props.data}
                        onChange={(changes) => {
                            this.props.onChange(changes);
                        }}
                        readOnly={
                            !isCreatingNewAccount(
                                getQueryParameters()["hierarchyid"],
                                this.props.data,
                                this.state.allAccounts
                            )
                        }
                    />
                )}
                < hr/>

                {!hasLegacyProduct && <Declarations {...this.props} onRef={(ref) => this.appendChild(ref)} />}
            </>
        );
    }

    private getDocumentWarning() {
        const selectedProducts = this.props.selectedProducts || [];
        const isBondType = selectedProducts.some(
            (prod) =>
                prod?.SubAccountType &&
                [SubAccountType.OffshoreBond, SubAccountType.OnshoreBond].includes(prod.SubAccountType)
        );
        if (isBondType) {
            return <Alert alertType={AlertType.Warning} message={<>{DocumentDeclarationWarningMessage}</>} />;
        } else {
            return <></>;
        }
    }
}
